export enum ELanguage {
    English = 1,
    French = 2,
    Spanish = 3,
}
export type ELanguageKeysType = keyof typeof ELanguage;
